import { render, staticRenderFns } from "./AdminClassView.vue?vue&type=template&id=72fde160&scoped=true"
import script from "./AdminClassView.vue?vue&type=script&lang=js"
export * from "./AdminClassView.vue?vue&type=script&lang=js"
import style0 from "./AdminClassView.vue?vue&type=style&index=0&id=72fde160&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72fde160",
  null
  
)

export default component.exports